import { Box, Typography } from "@mui/material";
import { FONT, WEIGHT } from '../../styles/foundation/typography';
import { NAVY, BORDER, SUBTLE, WHITE, LIGHT_BG } from '../../styles/foundation/colors';
import { SHADOW } from '../../styles/foundation/effects';

export const cardSx = {
    bgcolor: WHITE, borderRadius: '12px', boxShadow: SHADOW.card,
    border: `1px solid ${BORDER}`, overflow: 'hidden',
};
const cardHeadSx = {
    display: 'flex', alignItems: 'center', gap: 1.25, px: 2, py: 1.5,
    borderBottom: `1px solid ${BORDER}`, bgcolor: LIGHT_BG,
};
const cardIcSx = {
    width: 28, height: 28, borderRadius: '8px', display: 'grid', placeItems: 'center',
    flex: '0 0 auto', '& svg': { fontSize: 17 },
};

/** Titled card — same shape as this page's other sections (Zone Override-style header +
 *  content pad), reused across the Tickets list, Create Ticket, and ticket detail pages so
 *  the module reads as one thing. Styled from this repo's own design tokens (not the admin
 *  panel's), matching the surrounding Help & Support page. */
const SectionCard = ({ icon, title, sub, children, headerExtra }) => (
    <Box sx={cardSx}>
        <Box sx={cardHeadSx}>
            <Box sx={cardIcSx}>{icon}</Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontFamily: FONT, fontSize: 13, fontWeight: WEIGHT.bold, color: NAVY }}>{title}</Typography>
                {sub && <Typography sx={{ fontFamily: FONT, fontSize: 12, color: SUBTLE }}>{sub}</Typography>}
            </Box>
            {headerExtra}
        </Box>
        <Box sx={{ p: 2 }}>{children}</Box>
    </Box>
);

export default SectionCard;
